export default "__VITE_ASSET__9ynbyYRD__"